import { Box } from 'design-system-web';

export default Box;
